import * as React from 'react';
import { FIELD_TYPE, simpleFieldForPath, equalsValidation,
  SimpleFormValidationConfig, requiredValidation, withSimpleForm } from 'app/infrastructure/simple-form';
import { STATE } from 'app/constants';
import { containerFactory } from 'app/infrastructure/redux';
import { actionCreators } from '../actions';
import { userSettingsTranslations, UserSettingsTranslation } from '../constants';
import { SimpleFormProps, SerializeType } from 'app/infrastructure/simple-form/types';
import { defaultSerializeMappings } from 'app/infrastructure/simple-form/serialize';
import { ModalWrapper } from 'app/components/modal-wrapper/modal-wrapper';

const SimpleForm = simpleFieldForPath(STATE.userSettings);

export interface ChangePasswordModalProps {
  version: string;
  translation?: UserSettingsTranslation;
  onClose: () => void;
  changePassword: (serialize: any) => void;
  validate: any;
}

export class ChangePassword extends React.PureComponent<ChangePasswordModalProps & SimpleFormProps, any> {
  public static statePath: string = STATE.userSettings;

  private changePasswordValidationConfig: SimpleFormValidationConfig = [
    requiredValidation('oldPassword'),
    requiredValidation('newPassword'),
    requiredValidation('confirmPassword'),
    equalsValidation('newPassword', 'confirmPassword')
  ];

  private changePassword = () => {
    const { validate, serialize, changePassword, translation } = this.props;
    validate(this.changePasswordValidationConfig, () => changePassword(serialize(defaultSerializeMappings)), translation.validation_error);
  };

  public render () {
    const { translation, onClose } = this.props;

    return <ModalWrapper
            headerTitle={translation.change_password}
            btnTitle={translation.change}
            btnCancelTitle={translation.cancel}
            onClose={onClose}
            onDone={this.changePassword}
            largeSize={false}
            closeOnDone={false}>
              <form>
                <SimpleForm
                  name="oldPassword"
                  type={FIELD_TYPE.PASSWORD}
                  serialize={{ type: SerializeType.PRIMITIVE_VALUE }}
                  label={{ text: translation.old_password, required: true }}
                  initialValue=""
                  />
                <SimpleForm
                  name="newPassword"
                  serialize={{ type: SerializeType.PRIMITIVE_VALUE }}
                  type={FIELD_TYPE.PASSWORD}
                  label={{ text: translation.new_password, required: true }}
                  initialValue=""
                  />
                <SimpleForm
                  name="confirmPassword"
                  serialize={{ type: SerializeType.PRIMITIVE_VALUE }}
                  type={FIELD_TYPE.PASSWORD}
                  label={{ text: translation.repeat_new_password, required: true }}
                  initialValue=""
                  />
                </form>
            </ModalWrapper>;
  }
}

const container = containerFactory(withSimpleForm(ChangePassword), actionCreators, null, userSettingsTranslations);

export { container as ChangePasswordModal };
